import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import {
  Button,
  makeStyles,
  TableFooter,
  TableCell,
  TableRow,
  CircularProgress,
} from "@material-ui/core";
import { Pagination } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../_metronic/_partials/dropdowns";
import { ProgressBar, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import Moment from "moment";
import {
  getBotAdminList1,
  getDetailContact,
  deleteReqHistory,
  getMyLicenseList,
  getBotAdminLicenseList,
  deleteBotAdmin,
  updateBotAdmin,
  resetPass,
} from "../modules/api";
import MUIDataTable from "mui-datatables";

export function BotAdminManage() {
  const [isShow, setIsShow] = useState(false);
  const [licenseReqList, setLicenseReqList] = useState([]);
  const [licenseReqDetail, setLicenseReqDetail] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [isShowBot, setIsShowBot] = useState(false);
  const [companyName, setCompanyName] = useState();
  const [selectReqList, setSelectReqList] = useState();
  const [licenseList, setLicenseList] = useState([]);
  const [expireList, setExpireList] = useState(0);
  const [selectBotName, setSelectBotName] = useState();
  const [selectLicense, setSelectLicense] = useState();
  const [selectBotList, setSelectBotList] = useState([]);

  const [input, setInput] = useState({
    companyName: "",
    department: "",
    phone: "",
    email: "",
    userType: "",
    reqType: "",
    licenseNumber: "",
    status: "",
    contents: "",
    procContents: "",
    userNo: "",
  });

  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    centeredHeader: {
      "& span": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
        fontWeight: "bold",
      },
    },
  }));

  const classes = useStyles();

  const fetchData = async () => {
    try {
      const result = await getBotAdminList1();
      console.log("getBotAdminList1", result);

      let list = [];
      result.data.map((data, index) => {
        if (data.deletedAt === null) {
          var obj = new Object();
          obj.idx = index;
          obj.no = data.no;
          obj.loginId = data.loginId;
          obj.companyName = data.companyName ? data.companyName : "";
          obj.status = data.status;
          obj.createdAt = data.createdAt
            ? Moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
            : "-";
          obj.updatedAt = data.updatedAt
            ? Moment(data.updatedAt).format("YYYY-MM-DD HH:mm:ss")
            : "-";

          list.push(obj);
        }
      });

      setLicenseReqList(list);
    } catch (e) {
      console.log(e);
      // Handle error
    }
  };

  useEffect(() => {
    setListLoading(true);
    setTimeout(async () => {
      fetchData();
      setListLoading(false);
    }, 1500);
  }, []);

  const detailReq = async (value) => {
    const res = await getDetailContact(value);
    console.log("getDetailContact", res);
    setLicenseReqDetail(res.data);
    toggleShow();
  };

  const resetPassword = async (id, email) => {
    const param = {
      botAdminList: id,
    };

    if (
      window.confirm(
        email +
          "계정의 패스워드를 초기화 하시겠습니까? \n(초기화된 패스워드는 해당 계정의 email주소로 전송 됩니다.)"
      )
    ) {
      const res = await resetPass(param);
      if (res.result) {
        alert("정상적으로 초기화되었습니다.");
        fetchData();
      } else {
        alert("정상적으로 초기화되지 않았습니다.");
        return false;
      }
    }
  };

  const delSingleBot = async (id) => {
    if (window.confirm("해당 계정을 하시겠습니까?")) {
      const param = {
        botAdminList: id,
      };
      const res = await deleteBotAdmin(param);
      if (res.result) {
        alert("정상적으로 삭제되었습니다.");
        fetchData();
      } else {
        alert("정상적으로 삭제되지 않았습니다.");
        return false;
      }
    }
  };

  const updateStatus = async (id, status) => {
    console.log("idid", id);
    console.log("status", status);
    const param = {
      botAdminList: id,
      botStatus: status,
    };
    const res = await updateBotAdmin(param);
    if (res.result) {
      alert("정상적으로 수정되었습니다.");
      fetchData();
    } else {
      alert("정상적으로 수정되지 않았습니다.");
      return false;
    }
  };

  const doUse = async () => {
    if (selectReqList === undefined || selectReqList === "") {
      alert("1개 이상의 계정을 선택해 주세요.");
      return false;
    }

    const param = {
      botAdminList: selectReqList,
      status: "Y",
    };

    const res = await updateBotAdmin(param);
    if (res.result) {
      alert("정상적으로 수정되었습니다.");
      fetchData();
    } else {
      alert("정상적으로 수정되지 않았습니다.");
      return false;
    }
  };

  const doNotUse = async () => {
    console.log("selectReqList", selectReqList);
    if (selectReqList === undefined || selectReqList === "") {
      alert("1개 이상의 계정을 선택해 주세요.");
      return false;
    }

    const param = {
      botAdminList: selectReqList,
      status: "N",
    };

    const res = await updateBotAdmin(param);
    if (res.result) {
      alert("정상적으로 수정되었습니다.");
      fetchData();
    } else {
      alert("정상적으로 수정되지 않았습니다.");
      return false;
    }
  };

  const delMultiBotAdmin = async () => {
    if (selectReqList === undefined || selectReqList === "") {
      alert("1개 이상의 계정을 선택해 주세요.");
      return false;
    }
    if (window.confirm("선택한 계정을 하시겠습니까?")) {
      const param = {
        botAdminList: selectReqList,
      };
      const res = await deleteBotAdmin(param);
      if (res.result) {
        alert("정상적으로 삭제되었습니다.");
        fetchData();
      } else {
        alert("정상적으로 삭제되지 않았습니다.");
        return false;
      }
    }
  };

  const columns = [
    {
      name: "no",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "companyName",
      label: "고객사명",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "loginId",
      label: "ID",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "status",
      label: "상태",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
        customBodyRender: (value, meta) => {
          let textLabel;
          let textColor;

          if (value === "Y") {
            textLabel = "사용";
            textColor = "label-success";
          } else if (value === "N") {
            textLabel = "사용중지";
            textColor = "label-primary";
          }
          return (
            <div>
              <span className={"label label-xl label-inline " + textColor}>
                {textLabel}
              </span>
            </div>
          );
        },
      },
    },
    {
      name: "createdAt",
      label: "가입 일시",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "updatedAt",
      label: "수정 일시",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "license",
      label: "라이선스",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center", fontSize: 15, fontWeight: "bold" },
        }),
        customBodyRender: (value, meta) => {
          // if (userNo.toString() === meta.rowData[6].toString()) {
          return (
            <div className="card-toolbar">
              <Button
                className={`btn font-weight-bolder font-size-sm mr-2`}
                style={{ background: "lightgray" }}
                onClick={() => {
                  getLicense(meta.rowData[0]);
                  // setInput({
                  // 	userNo: meta.rowData[0],
                  // });
                  // setIsShow(true);
                }}
              >
                보기
              </Button>
            </div>
          );
          // }
        },
      },
    },
    {
      name: "action",
      label: "작업",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: "center",
            fontSize: 15,
            fontWeight: "bold",
            width: "300px",
          },
        }),
        customBodyRender: (value, meta) => {
          // console.log("metameta", meta);
          // if (userNo.toString() === meta.rowData[6].toString()) {
          return (
            <div>
              <Button
                className={`btn btn-xs font-weight-bolder btn-primary font-size-sm mr-2`}
                onClick={() => {
                  delSingleBot(meta.rowData[0]);
                }}
              >
                삭제
              </Button>
              <Button
                className={`btn btn-xs font-weight-bolder font-size-sm mr-2`}
                style={{ background: "lightgray" }}
                type="button"
                onClick={() => {
                  updateStatus(
                    meta.rowData[0],
                    meta.rowData[3] === "Y" ? "N" : "Y"
                  );
                }}
              >
                {meta.rowData[3] === "Y" ? "사용중지" : "사용"}
              </Button>
              <Button
                className={`btn btn-xs font-weight-bolder font-size-sm mr-2`}
                style={{ background: "lightgray" }}
                type="button"
                onClick={() => {
                  resetPassword(meta.rowData[0], meta.rowData[2]);
                }}
              >
                패스워드 초기화
              </Button>
            </div>
            // <div className="card-toolbar">
            //   <Dropdown className="dropdown-inline">
            //     <Dropdown.Toggle
            //       className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
            //       variant="transparent"
            //       id="dropdown-autoClose-true"
            //       as={DropdownCustomToggler}
            //     >
            //       <i className="ki ki-bold-more-hor" />
            //     </Dropdown.Toggle>
            //     <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
            //       {/* <ul className="navi"> */}

            //       <Dropdown.Item
            //         className="navi-item"
            //         onClick={() => {
            //           console.log("meta", meta.rowData);
            //           delSingleBot(meta.rowData[0]);
            //         }}
            //       >
            //         삭제
            //       </Dropdown.Item>
            //       <Dropdown.Item
            //         className="navi-item"
            //         onClick={() => {
            //           updateStatus(
            //             meta.rowData[0],
            //             meta.rowData[3] === "Y" ? "N" : "Y"
            //           );
            //         }}
            //       >
            //         {meta.rowData[3] === "Y" ? "사용중지" : "사용"}
            //       </Dropdown.Item>
            //       <Dropdown.Item
            //         className="navi-item"
            //         onClick={() => {
            //           // console.log("meta", meta.rowData);
            //           resetPassword(meta.rowData[0]);
            //         }}
            //       >
            //         패스워드 초기화
            //       </Dropdown.Item>
            //       {/* </ul> */}
            //     </Dropdown.Menu>
            //   </Dropdown>
            // </div>
          );
          // }
        },
      },
    },
  ];

  const options = {
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    rowsPerPage: 15,
    rowsPerPageOptions: [],
    selectToolbarPlacement: "none",
    selectableRows: true,
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      let temp = [];
      let indexes = [];
      rowsSelected.forEach((row) => {
        indexes.push(row);
      });
      licenseReqList.map((data, index) => {
        if (indexes.includes(data.idx)) {
          temp.push(data.no);
        }
      });
      console.log("indexes", indexes);
      console.log("temp", temp.toString());
      setSelectReqList(temp.toString());
    },

    textLabels: {
      body: {
        noMatch: listLoading ? (
          <CircularProgress size={25} color={"inherit"} />
        ) : licenseReqList.length > 0 ? (
          ""
        ) : (
          "검색 결과가 없습니다."
        ),
      },
    },
  };

  const toggleShow = () => {
    setIsShow(!isShow);
  };

  const toggleShowBot = () => {
    setIsShowBot(!isShowBot);
  };

  const delReqHistory = async () => {
    if (selectReqList === undefined) {
      alert("1개 이상의 내역을 선택해 주세요.");
      return false;
    }

    if (window.confirm("라이선스 문의 내역을 삭제하시겠습니까?")) {
      const res = await deleteReqHistory(selectReqList);
      if (res.result) {
        alert("정상적으로 삭제되었습니다.");
        fetchData();
      } else {
        alert("정상적으로 삭제되지 않았습니다.");
        return;
      }
    }
  };

  const getLicense = async (id) => {
    const res = await getBotAdminLicenseList(id);
    console.log("resres", res);
    setLicenseList(res.data);
    let count = 0;
    res.data.map((data, index) => {
      if (data.remainDays === 0) {
        count = count + 1;
      }
    });
    setExpireList(count);
    toggleShow();
  };

  const license = licenseList.map((data, index) => {
    console.log("data.remainDays", data);
    // console.log("data.remainDays", data.remainDays);
    // let remainList = [];

    let startDate = new Date(data.startAt);
    let nowDate = new Date();
    let realBotAmount = 0;
    for (let i = 0; i < data.botList.length; i++) {
      if (data.botList[i].deletedAt === null) {
        realBotAmount = realBotAmount + 1;
      }
    }

    let useDays = Moment(data.endAt).diff(data.startAt, "days");
    let todayDiff = Moment(new Date()).diff(data.startAt, "days");
    let usedDays;
    let expireText;
    if (todayDiff < 0) {
      usedDays = 0;
    } else if (todayDiff > useDays) {
      usedDays = useDays;
      expireText = "기간만료";
    } else {
      usedDays = todayDiff;
    }

    let useRate = Math.floor(
      isNaN((usedDays / useDays) * 100) ? 0 : (usedDays / useDays) * 100
    );

    // console.log("todayDiff", todayDiff);

    const noStyles = {
      border: "solid 2px #fff",
      padding: 10,
      borderRadius: 10,
      backgroundColor: "rgb(255,255,255)",
    };

    return (
      <li
        className="mb-10"
        style={noStyles}
        onClick={
          useRate >= 100 || realBotAmount === data.botAmount || todayDiff < 0
            ? ""
            : () => {
                // setChoiceLicenseName(data.licenseNumber);
                // setChoiceLicenseNo(data.no);
                // setChoiceIndex(index);
              }
        }
      >
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ marginRight: 100 }}
        >
          <p className="mb-0 license-number">
            {data.licenseNumber} ({data.botAmount}bot for {useDays}days)
          </p>
          <div
            className="font-weight-bold"
            style={{ textDecoration: "underline" }}
            onClick={() => {
              toggleShowBot();
              setSelectBotList(data.botList);
              setSelectBotName(
                realBotAmount + "Bot /" + data.botAmount + "Bot"
              );
              setSelectLicense(
                data.licenseNumber +
                  " (" +
                  data.botAmount +
                  "bot for" +
                  data.term +
                  "days)"
              );
            }}
          >
            {realBotAmount}Bot / {data.botAmount}Bot
          </div>
        </div>
        <small className="mb-1 d-flex text-muted">
          <span style={{ paddingTop: "2px", marginRight: "10px" }}>
            {Moment(data.startAt).format("YY-MM-DD")} –{" "}
            {Moment(data.endAt).format("YY-MM-DD")}
          </span>
          <span style={{ paddingTop: "2px" }}> {expireText}</span>
        </small>
        <div className="progress-wrap d-flex align-items-center justify-content-between">
          <div className="w-100">
            <ProgressBar now={useRate} />
          </div>
          <p className="mb-0 ml-2 days text-right">
            {usedDays} / {useDays}days
          </p>
        </div>
      </li>
    );
  });

  return (
    <div id="pageid31">
      {/* Bot 추가 Modal 시작 */}
      <Modal
        show={isShow}
        size="lg"
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">라이선스</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          <div className="text-right mb-10">
            <p>
              총 <b>{licenseList.length}개</b> 라이선스 중{" "}
              <b>{licenseList.length - expireList}개</b>가 활성화 중이며,{" "}
              <b>{expireList}개</b>가 만료 되었습니다
            </p>
          </div>
          <ul className="mb-15 pl-0 no-list-style pr-2">
            {licenseList.length > 0 ? (
              license
            ) : (
              <div className="text-center" style={{ marginTop: 50 }}>
                <p>사용 가능한 라이선스가 존재 하지 않습니다.</p>
              </div>
            )}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={() => {
                toggleShow();
                // setChoiceIndex("");
              }}
              className="btn btn-light btn-elevate"
            >
              취소
            </button>
            <> </>
            <button
              type="button"
              onClick={() => {
                toggleShow();
                // setChoiceIndex("");
              }}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={isShowBot}>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">Bot 확인</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="d-flex align-items-center justify-content-between mb-5">
            <p className="mb-0 license-number">{selectLicense}</p>
            <p className="mb-0 font-weight-bold">{selectBotName}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Bot ID</th>
                <th>Bot 상태</th>
              </tr>
            </thead>
            <tbody>
              {selectBotList.length > 0 &&
                selectBotList.map((data, index) => {
                  let textLabel;
                  let textColor;

                  if (data.accountStatus === 2) {
                    textLabel = "사용";
                    textColor = "label-success";
                  } else if (data.accountStatus === 1) {
                    textLabel = "사용중지";
                    textColor = "label-primary";
                  } else if (data.accountStatus === 3) {
                    textLabel = "기간만료";
                    textColor = "label-secondary";
                  }
                  return (
                    <tr>
                      <td>{data.loginId}</td>
                      <td>
                        <span
                          className={"label label-xl label-inline " + textColor}
                        >
                          {textLabel}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              {selectBotList.length === 0 && (
                <tr>
                  <td colSpan="2">
                    <span>등록된 Bot이 없습니다.</span>
                  </td>
                </tr>
              )}
              {/* <tr>
								<td>Logan1</td>
								<td>
									<span className="label label-xl label-inline label-success">
										사용
									</span>
								</td>
							</tr>
							<tr>
								<td>Logan2</td>
								<td>
									<span className="label label-xl label-inline label-primary">
										사용중지
									</span>
								</td>
							</tr>
							<tr>
								<td>Logan3</td>
								<td>
									<span className="label label-xl label-inline label-secondary">
										기간만료
									</span>
								</td>
							</tr> */}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleShowBot}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* Bot 추가 Modal 끝 */}

      <div style={{ marginTop: 30 }}>
        <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
          Bot 관리자 계정 관리
        </h3>
      </div>
      <div className="top-row gutter-b d-flex align-items-center flex-column">
        <div
          className="d-flex align-items-center justify-content-end w-100"
          style={{ marginTop: 50 }}
        >
          <div>
            <Button
              className={`btn btn-info font-weight-bolder font-size-sm mr-2`}
              // style={{ border: "solid 1px #D1D3E0" }}
              onClick={doUse}
            >
              사용
            </Button>
          </div>
          <div>
            <Button
              className={`btn font-weight-bolder font-size-sm mr-2`}
              style={{ background: "lightgray" }}
              onClick={doNotUse}
            >
              사용중지
            </Button>
          </div>
          <div>
            <Button
              className={`btn btn-danger font-weight-bolder font-size-sm mr-2`}
              // style={{ border: "solid 1px #D1D3E0" }}
              onClick={delMultiBotAdmin}
            >
              삭제
            </Button>
          </div>
        </div>
      </div>

      <div className="gutter-b">
        <div className="table-responsive">
          <MUIDataTable
            // title={"Bot 관리"}
            data={licenseReqList}
            columns={columns}
            options={options}
          />
        </div>
      </div>
    </div>
  );
}
export default BotAdminManage;
